import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { FormControl, NgForm, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { NotifierService } from "angular-notifier";
import { ToastrService } from "ngx-toastr";
import { Observable, Subject, Subscription } from "rxjs";
import { map, startWith, takeUntil } from "rxjs/operators";
import { Message } from "src/app/core/class/message";
import { EnumAdjustedContents } from "src/app/core/constants/contract";
import { EnumCriteriaCode } from "src/app/core/constants/criteria-code";
import { CommonService } from "src/app/core/services/common.service";
import { CreateContractMohaService } from "src/app/core/services/create-contract-moha.service";
import { CustomerService } from "src/app/core/services/customer.service";
import { DocumentTypeService } from "src/app/core/services/document-type.service";
import { NotificationService } from "src/app/core/services/notification.service";
import { BaseComponent } from "src/app/shared/components/base/base.component";

interface IMergeFieldData{
  mergeField: any;
  isGroup?: boolean;
  startGroup?: string;
  endGroup?: string;
  children?: any;
}

interface IReportCriterionRow {
  code: string;
  name: string;
  inputType: string;
  order?: number;
  parentCode?: string;
  controlField?: FormControl;
  displayOrder?: string;
  level?: number;
  rowType: 'header' | 'subheader' | 'criterion';
  expanded?: boolean;
}

const FormActionType = 0;
const FileUploadType = 1;

@Component({
  selector: 'app-fill-labor-contract-report-moha',
  templateUrl: './fill-labor-contract-report-moha.component.html',
  styleUrls: ['./fill-labor-contract-report-moha.component.scss']
})
export class FillLaborContractReportMohaComponent extends BaseComponent implements OnInit, AfterViewInit {
  @ViewChild('f', { read: NgForm, static: true }) ngForm: NgForm;
  customerControl: FormControl = new FormControl(null, [Validators.required])
  searchCustomerControl: FormControl = new FormControl('')

  listDataSource: any = [];
  listDataTable: IReportCriterionRow[] = [];
  listDataChangeSource: any = [];
  displayedColumns = ["stt", "nameCriteria", "infoTemplate"];
  headerColumns = ["groupHeader"];
  private rawProperties: any[] = [];
  private readonly expandedGroups = new Map<string, boolean>();
  private readonly parentCodeMap = new Map<string, string>();
  private readonly rawDateInputMap = new Map<string, string>();
  private readonly representativeRequiredCodes = [
    EnumCriteriaCode.ndd_so_dinh_danh,
    EnumCriteriaCode.ndd_ho_ten,
    EnumCriteriaCode.ndd_quoc_tich,
    EnumCriteriaCode.ndd_ngay_sinh,
    EnumCriteriaCode.ndd_gioi_tinh,
    EnumCriteriaCode.ndd_dia_chi,
    EnumCriteriaCode.ndd_so_dien_thoai,
    EnumCriteriaCode.ndd_quan_he_nld
  ];
  isUpdateValueCustomer: boolean = false
  minDate = new Date();
  disabledFutureDate = (current: Date): boolean =>
    !!current && current.getTime() > this.minDate.getTime();

  listCustomer: any[] = [];
  listCustomerFilter: Observable<any>;

  dataDropDownPropertiesOrigin: IMergeFieldData[] = []
  optionsMap = new Map<string, IMergeFieldData[]>();

  isPlContract: boolean = false;
  public enumAdjustedContents = EnumAdjustedContents;
  titleChange: string = '';
  _onDestroy = new Subject<void>();
  subscriptions: Subscription = new Subscription();
  contractEmploymentDocumentTypeDetails: any[] = [];
  customerName: string = '';
  constructor(
    private dialog: MatDialog,
    public commonService: CommonService,
    public message: Message,
    private notifier: NotifierService,
    private router: Router,
    public toast: ToastrService,
    public route: ActivatedRoute,
    private notificationService: NotificationService,
    private translateSvr: TranslateService,
    private documentTypeService: DocumentTypeService,
    private createContractMohaService: CreateContractMohaService,
    private customerService: CustomerService,
  ) {
    super(commonService, message);
    this.notifier = notifier;
    this.customerControl.valueChanges.subscribe((res) => {
      this.changeCustomer(res)
      if(!this.isUpdateValueCustomer){
        this.isUpdateValueCustomer = true
      }
    })
  }
  ngAfterViewInit(): void {
    setTimeout(() => {
      const el = document.getElementById('step_title');
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 200);
  }

  async ngOnInit() {
    this.subscribeData();
    // call api lấy thông tin form
    await this.loadDataTable();
    // Lấy danh sách KH cá nhân
    this.getDataListCustomer()
    if(this.createContractMohaService.prevStep.getValue() == 1){
      this.isUpdateValueCustomer = false
      this.fillDataInTable()
    }
    if(this.createContractMohaService.prevStep.getValue() == 3 || this.createContractMohaService.createContractType.getValue() == FileUploadType){
      this.isUpdateValueCustomer = false
      // Mapping data ở hợp đồng để path vào form
      this.mappingDataMFFormService()
    }
    // Khi đổi data người lao động
    this.filterCustomerData()
    window.scrollTo(0, 0);
    this.notificationService.subscribeErrorService();

    // validate form
    this.createContractMohaService.saveStep3.pipe(
      takeUntil(this._onDestroy)
    ).subscribe((res) => {
      this.markAsTouchedOrUnTouchedStep3(res)
      if (this.isPlContract) {
        this.saveDataChangeMF(res)
      } else {
        this.saveDataMF(res)
      }
    })
  }

  subscribeData() {
    this.subscriptions.add(
      this.createContractMohaService.originalContract.asObservable().subscribe(rs => {
        if (rs) {
          this.isPlContract = true;
        } else {
          this.isPlContract = false;
        }
      })
    );
    this.subscriptions.add(
      this.createContractMohaService.adjustedContentSelected.asObservable().subscribe(rs => {
        if (rs) {
          this.titleChange = this.createContractMohaService.convertTitleContent(rs.type);
          let listDataChangeSource = this.mapDataMergeField(rs.properties, false, true)
          this.listDataChangeSource = listDataChangeSource;
          this.buildChangeOptions()
        }
      })
    );
  }

  getDataListCustomer(){
    this.listCustomer = this.createContractMohaService.recordsPartySign.getValue()
    this.listCustomer = [...this.listCustomer.filter((customer) => customer.customerType && customer.customerType == 10000 && !customer.isCreatedSide)]
    const url = this.router.url
    if(url.includes("/home-enterprise/contract-digitzation-moha") || !this.createContractMohaService.customerMohaId){
      if(url.includes("/home-enterprise/contract-digitzation-moha") && this.createContractMohaService.customerMohaId &&
      this.listCustomer.find((customer) => customer.customerType && customer.customerId == this.createContractMohaService.customerMohaId)){
        this.customerControl.patchValue(this.createContractMohaService.customerMohaId)
      }
      else{
        if(this.listCustomer && this.listCustomer.length){
          this.customerControl.patchValue(this.listCustomer[0].customerId)
        }
      }
    }
    else{
      if(this.listCustomer && this.listCustomer.length){
        let existCustomer = this.listCustomer.find((customer) => customer.customerType && customer.customerId == this.createContractMohaService.customerMohaId)
        if(existCustomer){
          this.customerControl.patchValue(this.createContractMohaService.customerMohaId)
        }
        else{
          if(this.listCustomer && this.listCustomer.length){
            this.customerControl.patchValue(this.listCustomer[0].customerId)
          }
        }
      }
    }
  }

  filterCustomerData(){
    this.listCustomerFilter = this.searchCustomerControl.valueChanges.pipe(
      takeUntil(this._onDestroy),
      startWith(""),
      map((value) => {
        if (!value) {
          return this.listCustomer;
        }
        return this.listCustomer.filter((st) => {
          const optionLabel = `${st.name}`;
          return optionLabel.toLowerCase().includes(value.trim().toLowerCase());
        });
      })
    );
  }

  ngOnDestroy() {
    this.notificationService.unsubscribeErrorService();
    this._onDestroy.next();
    this._onDestroy.complete();
    this.subscriptions.unsubscribe();
    this.createContractMohaService.saveStep3.next(false);
  }

  getDataById(id: string) {
    this.documentTypeService.getLaborReportById(id).subscribe((res) => {
      if (res.data) {
        this.handleDataDetail(res.data)
      } else {
        this.toast.error(
          this.message.getMessage('messages.category_not_permission')
        );
      }
    });
  }

  handleDataDetail(data: any){
    if(data){
      if(data.contractEmploymentDocumentTypeDetails && data.contractEmploymentDocumentTypeDetails.length){
        data.contractEmploymentDocumentTypeDetails.forEach((item: any) => {
          let idxExist = this.listDataSource.findIndex((propertie: any) => propertie.code == item.code)
          if(idxExist >= 0 && this.listDataSource[idxExist] && this.listDataSource[idxExist].controlField){
            this.listDataSource[idxExist].controlField.patchValue(item.mergeField)
            this.buildOptions()
          }
        })
      }
    }
  }

  async changeCustomer(event: any){
    if(!event || this.createContractMohaService.createContractType.getValue() != 1) return
    let customer = this.listCustomer.find((data: any) => data.customerId == event)
    if(customer){
      let detailCustomer = await this.getDetailCustomer(customer.customerId)
      if(detailCustomer && detailCustomer.data){
        customer = {
          ...customer,
          ...detailCustomer.data
        }
        this.customerName = customer.name || '';
      }
    }else{
      this.customerName = '';
    }
    const checkExistAndPatchValue = (row: any, valueFill: any) => {
      let isExistValueInService = this.createContractMohaService.contractMohaFields.find((fieldMoha: any) => fieldMoha.key == row.code)
      if(!isExistValueInService || !isExistValueInService.value || this.isUpdateValueCustomer){
        row.controlField.patchValue(valueFill)
      }
    }
    if(customer){
      this.listDataSource.forEach((row: any) => {
        if(row.code == EnumCriteriaCode.nld_ho_ten && customer.name){
          checkExistAndPatchValue(row, customer.name)
        }
        else if(row.code == EnumCriteriaCode.nld_so_dien_thoai && customer.phone){
          checkExistAndPatchValue(row, customer.phone)
        }
        else if(row.code == EnumCriteriaCode.nld_email && customer.email){
          checkExistAndPatchValue(row, customer.email)
        }
        else if(row.code == EnumCriteriaCode.nld_so_dinh_danh && customer.certificateNo){
          checkExistAndPatchValue(row, customer.certificateNo)
        }
        else if(row.code == EnumCriteriaCode.nld_gioi_tinh){
          checkExistAndPatchValue(row, customer.sex ? '0' : '1')
        }
        else if(row.code == EnumCriteriaCode.nld_ngay_sinh && customer.birthday){
          checkExistAndPatchValue(row, new Date(customer.birthday))
        }
        else if(row.code == EnumCriteriaCode.nld_ma_bhxh){
          // row.controlField.patchValue(customer.name)
        }
      });
    }
  }

  async getDetailCustomer(id: any){
    let customer = await this.customerService.getCustomer(id).toPromise()
    return customer
  }

  async loadDataTable() {
    let res: any = null
    if(this.createContractMohaService.createContractType.getValue() == FormActionType){
      let dataApi = await this.documentTypeService.getInfoProperties(this.createContractMohaService.selectedTemplate.getValue().id).toPromise()
      if (!dataApi || !dataApi.data || !dataApi.data.employmentPropertieDtos) {
        return;
      }
      res = dataApi.data.employmentPropertieDtos
      this.rawProperties = res;
      this.contractEmploymentDocumentTypeDetails = dataApi.data.contractEmploymentDocumentTypeDetails;
    }
    else{
      let dataApi = await this.documentTypeService.getInfoProperties(null, false).toPromise()
      if (!dataApi || !dataApi.data) {
        return;
      }
      res = dataApi.data
      this.rawProperties = res;
    }
    let listProperties = this.mapDataMergeField(res, this.isPlContract)
    this.listDataSource = listProperties || [];
    this.configureDynamicValidation(this.listDataSource);
    this.rebuildTableRows();
    this.buildOptions()
  }

  mapDataMergeField(data: any, isPlContract: boolean = false, isChangeType: boolean = false){
    if(!data || !data.length) return
    let dataPropertiesConvert = []
    data.filter((field: any) => field.inputType !== 'HEADER').forEach((field: any, idx: number) => {
      let validators: any = []
      const isConditionallyRequired = this.isConditionallyRequiredField(field.code);
      if(!isConditionallyRequired && field.isRequired){
        validators = !isPlContract ? [Validators.required] : []
      }
      // if(field.regex && field.inputType == 'TEXT'){
      //   validators = !isPlContract ? [...validators, Validators.pattern(field.regex)] : []
      // }
      if (field.regex && field.inputType === 'TEXT' && !isPlContract) {
        try {
          validators.push(
            Validators.pattern(new RegExp(field.regex))
          );
        } catch (error) {
          console.error(
            `Regex không hợp lệ tại field ${field.code}:`,
            field.regex,
            error
          );
        }
      }
      let formControl = new FormControl({ value: null, disabled: isPlContract }, validators)
      // if (isPlContract) {
      //   formControl.disable()
      // }
      let propertiesInfo: any = {
        ...field,
        isRequired: isConditionallyRequired ? false : field.isRequired,
        baseValidators: validators,
        stt: idx + 1,
        dataDropDown: this.dataDropDownPropertiesOrigin,
        controlField: formControl
      }
      formControl.valueChanges.subscribe(() => {
        if (isChangeType) {
          this.updateValueChangeInService(propertiesInfo)
        } else {
          this.updateValueInService(propertiesInfo)
        }
      })
      dataPropertiesConvert.push(propertiesInfo)
    });
    return dataPropertiesConvert
  }

  private rebuildTableRows() {
    const criteriaMap = new Map<string, IReportCriterionRow>();
    this.listDataSource.forEach((criterion: IReportCriterionRow) =>
      criteriaMap.set(criterion.code, criterion)
    );

    const nodes: IReportCriterionRow[] = (this.rawProperties || [])
      .map((item: any) => item.inputType === 'HEADER'
        ? {
            ...item,
            rowType: 'header',
            expanded: this.expandedGroups.has(item.code)
              ? this.expandedGroups.get(item.code)
              : true
          }
        : criteriaMap.get(item.code))
      .filter((item: IReportCriterionRow) => !!item);

    const childrenMap = new Map<string, IReportCriterionRow[]>();
    this.parentCodeMap.clear();
    nodes.forEach((node: IReportCriterionRow) => {
      const parentCode = node.parentCode || '';
      this.parentCodeMap.set(node.code, parentCode);
      const children = childrenMap.get(parentCode) || [];
      children.push(node);
      childrenMap.set(parentCode, children);
    });

    const effectiveOrder = (node: IReportCriterionRow): number => {
      const children = childrenMap.get(node.code) || [];
      return node.inputType === 'HEADER' && children.length
        ? Math.min(...children.map(effectiveOrder))
        : Number(node.order || 0);
    };
    childrenMap.forEach(children =>
      children.sort((first, second) => effectiveOrder(first) - effectiveOrder(second))
    );

    const rows: IReportCriterionRow[] = [];
    let runningOrder = 0;
    const appendNode = (node: IReportCriterionRow, displayOrder: string, level: number) => {
      const isHeader = node.inputType === 'HEADER';
      rows.push({
        ...node,
        displayOrder,
        level,
        rowType: isHeader ? 'subheader' : 'criterion'
      });
      if (isHeader) {
        (childrenMap.get(node.code) || []).forEach((child, index) =>
          appendNode(child, `${displayOrder}.${index + 1}`, level + 1)
        );
      }
    };

    const rootNodes = childrenMap.get('') || [];
    const rootHeaders = rootNodes.filter(node => node.inputType === 'HEADER');
    if (!rootHeaders.length) {
      rootNodes.forEach(node => {
        runningOrder++;
        appendNode(node, `${runningOrder}`, 1);
      });
    } else {
      rootHeaders.forEach(root => {
        rows.push({ ...root, displayOrder: null, level: 0, rowType: 'header' });
        (childrenMap.get(root.code) || []).forEach(child => {
          runningOrder++;
          appendNode(child, `${runningOrder}`, 1);
        });
      });
    }
    this.listDataTable = rows;
  }

  toggleGroup(row: IReportCriterionRow) {
    row.expanded = !row.expanded;
    this.expandedGroups.set(row.code, row.expanded);
  }

  isRowVisible(row: IReportCriterionRow): boolean {
    let parentCode = row.parentCode || '';
    while (parentCode) {
      if (this.expandedGroups.get(parentCode) === false) return false;
      parentCode = this.parentCodeMap.get(parentCode) || '';
    }
    return true;
  }

  trackByCode(_: number, row: IReportCriterionRow): string {
    return row.code;
  }

  isHeaderRow = (_: number, row: IReportCriterionRow) => row.rowType === 'header';
  isCriterionRow = (_: number, row: IReportCriterionRow) => row.rowType !== 'header';

  onSelectionChange() {
    this.buildOptions();
  }

  private buildOptions() {
    this.optionsMap.clear();
    this.listDataSource.forEach((item: any) => {
      if(item.inputType == "DROPDOWN" && item.metadata){
        this.setDropdownOptions(item);
      }
    });
  }
  private buildChangeOptions() {
    this.listDataChangeSource.forEach((item: any) => {
      if(item.inputType == "DROPDOWN" && item.metadata){
        this.setDropdownOptions(item);
      }
    });
  }

  private setDropdownOptions(item: any): void {
    try {
      const options = typeof item.metadata === 'string'
        ? JSON.parse(item.metadata)
        : item.metadata;
      this.optionsMap.set(item.code, Array.isArray(options) ? options : []);
    } catch (error) {
      this.optionsMap.set(item.code, []);
      console.error(`Metadata dropdown không hợp lệ tại field ${item.code}:`, item.metadata, error);
    }
  }

  isBirthDateField(code: string): boolean {
    return code === EnumCriteriaCode.nld_ngay_sinh
      || code === EnumCriteriaCode.ndd_ngay_sinh;
  }

  private isConditionallyRequiredField(code: any): boolean {
    return this.representativeRequiredCodes.indexOf(code) >= 0
      || code === EnumCriteriaCode.nndh_bat_dau
      || code === EnumCriteriaCode.nndh_ket_thuc
      || code === EnumCriteriaCode.so_thang_thuc_hien
      || code === EnumCriteriaCode.ngay_ket_thuc_hdld;
  }

  private configureDynamicValidation(rows: any[]): void {
    if (!rows || !rows.length || this.isPlContract) return;

    const watch = (code: string, update: () => void) => {
      const row = this.getRow(rows, code);
      if (row && row.controlField) {
        this.subscriptions.add(row.controlField.valueChanges.subscribe(update));
      }
    };

    const updateRepresentative = () => {
      const birthDate = this.getRowValue(rows, EnumCriteriaCode.nld_ngay_sinh);
      const isUnder15 = this.isUnder15YearsOld(birthDate);
      this.representativeRequiredCodes.forEach(code =>
        this.setConditionalRequired(this.getRow(rows, code), isUnder15)
      );
    };

    const updateHazardousJob = () => {
      const hazardousValue = this.getRowValue(rows, EnumCriteriaCode.nndh_is_doc_hai);
      const isHazardous = hazardousValue === true
        || String(hazardousValue) === '1'
        || String(hazardousValue).toLowerCase() === 'true';
      this.setConditionalRequired(this.getRow(rows, EnumCriteriaCode.nndh_bat_dau), isHazardous);
      // this.setConditionalRequired(this.getRow(rows, EnumCriteriaCode.nndh_ket_thuc), isHazardous);
      this.validateDateRelations(rows);
    };

    const updateContractType = () => {
      const isLimitedTerm = String(this.getRowValue(rows, EnumCriteriaCode.loai_hop_dong)) === '1';
      this.setConditionalRequired(this.getRow(rows, EnumCriteriaCode.so_thang_thuc_hien), isLimitedTerm);
      this.setConditionalRequired(this.getRow(rows, EnumCriteriaCode.ngay_ket_thuc_hdld), isLimitedTerm);
      this.validateDateRelations(rows);
    };

    watch(EnumCriteriaCode.nld_ngay_sinh, () => {
      updateRepresentative();
      this.validateDateRelations(rows);
    });
    watch(EnumCriteriaCode.nndh_is_doc_hai, updateHazardousJob);
    watch(EnumCriteriaCode.nndh_bat_dau, () => this.validateDateRelations(rows));
    watch(EnumCriteriaCode.nndh_ket_thuc, () => this.validateDateRelations(rows));
    watch(EnumCriteriaCode.loai_hop_dong, updateContractType);
    watch(EnumCriteriaCode.ngay_bat_dau_hdld, () => this.validateDateRelations(rows));
    watch(EnumCriteriaCode.ngay_ket_thuc_hdld, () => this.validateDateRelations(rows));

    updateRepresentative();
    updateHazardousJob();
    updateContractType();
    this.validateDateRelations(rows);
  }

  private getRow(rows: any[], code: string): any {
    return rows.find((row: any) => row.code === code);
  }

  private getRowValue(rows: any[], code: string): any {
    const row = this.getRow(rows, code);
    return row && row.controlField ? row.controlField.value : null;
  }

  private setConditionalRequired(row: any, required: boolean): void {
    if (!row || !row.controlField) return;
    row.isRequired = required;
    const tableRow = this.listDataTable.find((item: IReportCriterionRow) => item.code === row.code);
    if (tableRow) {
      (tableRow as any).isRequired = required;
    }
    const validators = [...(row.baseValidators || [])];
    if (required) validators.push(Validators.required);
    row.controlField.setValidators(validators);
    row.controlField.updateValueAndValidity({ emitEvent: false });
  }

  private isUnder15YearsOld(value: any): boolean {
    const birthDate = this.toValidDate(value);
    if (!birthDate) return false;
    const fifteenthBirthday = new Date(
      birthDate.getFullYear() + 15,
      birthDate.getMonth(),
      birthDate.getDate()
    );
    return fifteenthBirthday.getTime() > new Date().getTime();
  }

  private toValidDate(value: any): Date | null {
    if (!value) return null;
    const date = value instanceof Date ? new Date(value.getTime()) : new Date(value);
    return isNaN(date.getTime()) ? null : date;
  }

  private getDateOnlyTime(date: Date): number {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
  }

  private setRelationError(row: any, errorKey: string, invalid: boolean): void {
    if (!row || !row.controlField) return;
    const errors = { ...(row.controlField.errors || {}) };
    if (invalid) {
      errors[errorKey] = true;
    } else {
      delete errors[errorKey];
    }
    row.controlField.setErrors(Object.keys(errors).length ? errors : null);
  }

  isDateRangeTouched(endCode: string): boolean {
    const startCode = endCode === EnumCriteriaCode.nndh_ket_thuc
      ? EnumCriteriaCode.nndh_bat_dau
      : EnumCriteriaCode.ngay_bat_dau_hdld;
    const start = this.getRow(this.listDataSource, startCode);
    const end = this.getRow(this.listDataSource, endCode);
    return !!((start && start.controlField.touched) || (end && end.controlField.touched));
  }

  private validateDateRelations(rows: any[]): void {
    const hazardousStart = this.getRow(rows, EnumCriteriaCode.nndh_bat_dau);
    const hazardousEnd = this.getRow(rows, EnumCriteriaCode.nndh_ket_thuc);
    const hazardousStartDate = this.toValidDate(hazardousStart && hazardousStart.controlField.value);
    const hazardousEndDate = this.toValidDate(hazardousEnd && hazardousEnd.controlField.value);
    this.setRelationError(
      hazardousEnd,
      'hazardousDateOrder',
      !!hazardousStartDate && !!hazardousEndDate
        && this.getDateOnlyTime(hazardousStartDate) > this.getDateOnlyTime(hazardousEndDate)
    );

    const contractStart = this.getRow(rows, EnumCriteriaCode.ngay_bat_dau_hdld);
    const contractEnd = this.getRow(rows, EnumCriteriaCode.ngay_ket_thuc_hdld);
    const employeeBirthDate = this.toValidDate(this.getRowValue(rows, EnumCriteriaCode.nld_ngay_sinh));
    const contractStartDate = this.toValidDate(contractStart && contractStart.controlField.value);
    const contractEndDate = this.toValidDate(contractEnd && contractEnd.controlField.value);

    this.setRelationError(
      contractStart,
      'contractStartNotAfterBirthDate',
      !!contractStartDate && !!employeeBirthDate
        && this.getDateOnlyTime(contractStartDate) <= this.getDateOnlyTime(employeeBirthDate)
    );
    this.setRelationError(
      contractEnd,
      'contractDateOrder',
      !!contractStartDate && !!contractEndDate
        && this.getDateOnlyTime(contractEndDate) < this.getDateOnlyTime(contractStartDate)
    );
  }

  getDisabledDateForField(row: any): ((current: Date) => boolean) | null {
    if (this.isBirthDateField(row.code)) return this.disabledFutureDate;

    if (row.code === EnumCriteriaCode.nndh_ket_thuc) {
      const startDate = this.toValidDate(this.getRowValue(this.listDataSource, EnumCriteriaCode.nndh_bat_dau));
      return (current: Date) => !!startDate
        && this.getDateOnlyTime(current) < this.getDateOnlyTime(startDate);
    }

    if (row.code === EnumCriteriaCode.ngay_bat_dau_hdld) {
      const birthDate = this.toValidDate(this.getRowValue(this.listDataSource, EnumCriteriaCode.nld_ngay_sinh));
      const endDate = this.toValidDate(this.getRowValue(this.listDataSource, EnumCriteriaCode.ngay_ket_thuc_hdld));
      return (current: Date) =>
        (!!birthDate && this.getDateOnlyTime(current) <= this.getDateOnlyTime(birthDate))
        || (!!endDate && this.getDateOnlyTime(current) > this.getDateOnlyTime(endDate));
    }

    if (row.code === EnumCriteriaCode.ngay_ket_thuc_hdld) {
      const startDate = this.toValidDate(this.getRowValue(this.listDataSource, EnumCriteriaCode.ngay_bat_dau_hdld));
      return (current: Date) => !!startDate
        && this.getDateOnlyTime(current) < this.getDateOnlyTime(startDate);
    }

    return null;
  }

  onDatePickerOpenChange(isOpen: boolean, row: any): void {
    if (!isOpen && row && row.controlField) {
      row.controlField.markAsTouched();
      this.validateDateRelations(this.listDataSource);
    }
  }

  saveDataMF(isValid: boolean = true){
    if(this.listDataSource && this.listDataSource.length){
      let dataSave = []
      this.listDataSource.forEach((row: any) => {
        dataSave.push({key: row.code, value: row.controlField.value})
      });
      this.createContractMohaService.contractMohaFields = dataSave || []
      this.createContractMohaService.customerMohaId = this.customerControl.value
    }
    if(isValid){
      this.validateDataStep3()
    }
  }
  saveDataChangeMF(isValid: boolean = true){
    if(this.listDataChangeSource && this.listDataChangeSource.length){
      let dataSave = []
      this.listDataChangeSource.forEach((row: any) => {
        dataSave.push({key: row.code, value: row.controlField.value})
      });
      // luu thong tin khi da xong o day
      this.createContractMohaService.contractMohaUpdateFields = dataSave || []
      // this.createContractMohaService.customerMohaId = this.customerControl.value
    }
    if(isValid){
      this.validateDataStepChange3()
    }
  }

  clearDataPropertie(target: number | IReportCriterionRow, type?: string | null){
    const idx = typeof target === 'number' ? target : -1;
    const row = typeof target === 'number' ? null : target;
    if (type === 'CHANGE') {
      const criterion = row || this.listDataChangeSource[idx];
      if(criterion && criterion.controlField){
        criterion.controlField.setValue('')
        this.buildChangeOptions()
      }
    } else {
      const criterion = row || this.listDataSource[idx];
      if(criterion && criterion.controlField){
        criterion.controlField.setValue('')
        this.buildOptions()
      }
    }
  }

  focusOutInput(target: number | IReportCriterionRow){
    const criterion = typeof target === 'number' ? this.listDataSource[target] : target;
    if(criterion && criterion.controlField && criterion.controlField.value){
      criterion.controlField.patchValue(String(criterion.controlField.value).trim())
    }
  }

  checkIsValidForm(){
    let isValidFormChild = true
    this.listDataSource.forEach((data: any) => {
      if(data.isRequired && !data.controlField.value){
        isValidFormChild = false
      }
    });
    return isValidFormChild
  }

  fillDataInTable(){
    this.mappingDataMFFormService(false)
    if(this.createContractMohaService.fieldData && this.createContractMohaService.fieldData.length){
      let result = this.flattenFieldConfigValue(this.createContractMohaService.fieldData)
        if (this.isPlContract) {
            this.listDataChangeSource.forEach(e => {
              const dataChange = this.contractEmploymentDocumentTypeDetails.find(type => type.code === e.code);
              if (dataChange) {
                e.mergeField = dataChange.mergeField;
              }
        })}
      if(result && result.length){
        result.forEach((mergeFieldObj: any) => {
          let indexLinkMergeField;
          if (this.isPlContract) {
            indexLinkMergeField = this.listDataChangeSource.findIndex((tableItem: any) =>  mergeFieldObj.fieldConfig && tableItem.mergeField == mergeFieldObj.fieldConfig.mergeField)
            if(indexLinkMergeField >= 0 && this.listDataChangeSource[indexLinkMergeField] && this.listDataChangeSource[indexLinkMergeField].controlField){
              let valueCriteria = this.getValueCriteriaByType(mergeFieldObj)

              if(this.listDataChangeSource[indexLinkMergeField].inputType == 'DROPDOWN'){
                if(valueCriteria && this.checkValueInDropDown(this.listDataChangeSource[indexLinkMergeField], valueCriteria)){
                  let valueInDropDown = this.getValueInDropdownByName(this.listDataChangeSource[indexLinkMergeField], valueCriteria)
                  if(valueInDropDown){
                    this.listDataChangeSource[indexLinkMergeField].controlField.patchValue(valueInDropDown)
                  }
                }
              }
              else if(this.listDataChangeSource[indexLinkMergeField].inputType == 'DATETIME'){
                if(valueCriteria && this.checkIsValidDate(valueCriteria)){
                  this.listDataChangeSource[indexLinkMergeField].controlField.patchValue(this.formatDate(valueCriteria))
                }
              }
              else{
                if(valueCriteria){
                  this.listDataChangeSource[indexLinkMergeField].controlField.patchValue(valueCriteria)
                }
              }
            }
          } else {
            indexLinkMergeField = this.listDataSource.findIndex((tableItem: any) =>  mergeFieldObj.fieldConfig && tableItem.mergeField == mergeFieldObj.fieldConfig.mergeField)
            if(indexLinkMergeField >= 0 && this.listDataSource[indexLinkMergeField] && this.listDataSource[indexLinkMergeField].controlField){
              let valueCriteria = this.getValueCriteriaByType(mergeFieldObj)

              if(this.listDataSource[indexLinkMergeField].inputType == 'DROPDOWN'){
                if(valueCriteria && this.checkValueInDropDown(this.listDataSource[indexLinkMergeField], valueCriteria)){
                  let valueInDropDown = this.getValueInDropdownByName(this.listDataSource[indexLinkMergeField], valueCriteria)
                  if(valueInDropDown){
                    this.listDataSource[indexLinkMergeField].controlField.patchValue(valueInDropDown)
                  }
                }
              }
              else if(this.listDataSource[indexLinkMergeField].inputType == 'DATETIME'){
                if(valueCriteria && this.checkIsValidDate(valueCriteria)){
                  this.listDataSource[indexLinkMergeField].controlField.patchValue(this.formatDate(valueCriteria))
                }
              }
              else{
                if(valueCriteria){
                  this.listDataSource[indexLinkMergeField].controlField.patchValue(valueCriteria)
                }
              }
            }
          }

        })
      }
    }
  }

  flattenFieldConfigValue(list: any[]): any[] {
    const result: any[] = [];

    const dfs = (nodes: any[]) => {
      for (const node of nodes || []) {
        // value khác rỗng
        if (node.value !== null && node.value !== undefined && String(node.value).trim() !== "") {
          result.push({
            fieldConfig: node.fieldConfig,
            value: node.value
          });
        }

        // duyệt children
        if (node.children && node.children.length) {
          dfs(node.children);
        }
      }
    };

    dfs(list);
    return result;
  }

  validateDataStep3(){
    let isValid = true
    for(let i = 0 ; i < this.listDataSource.length; i++){
      if(this.listDataSource[i] && this.listDataSource[i].isRequired && this.listDataSource[i].controlField && !this.listDataSource[i].controlField.value){
        isValid = false
        break;
      }

      if(this.listDataSource[i] && this.listDataSource[i].regex && this.listDataSource[i].controlField && this.listDataSource[i].controlField.value &&
        !this.listDataSource[i].controlField.value.match(this.listDataSource[i].regex)
      ){
        isValid = false
        break;
      }

      if(this.listDataSource[i] && this.listDataSource[i].controlField && this.listDataSource[i].controlField.value &&
        this.listDataSource[i].controlField.invalid
      ){
        isValid = false
        break;
      }
    }
    let isErrorValidateCustom = !!this.createContractMohaService.getErrorMessageStep3()
    this.createContractMohaService.isSuccessStep3.next(isValid && !isErrorValidateCustom)
    return (isValid && !isErrorValidateCustom)
  }
  validateDataStepChange3(){
    let isValid = true
    for(let i = 0 ; i < this.listDataChangeSource.length; i++){
      if(this.listDataChangeSource[i] && this.listDataChangeSource[i].isRequired && this.listDataChangeSource[i].controlField && !this.listDataChangeSource[i].controlField.value){
        isValid = false
        break;
      }

      if(this.listDataChangeSource[i] && this.listDataChangeSource[i].regex && this.listDataChangeSource[i].controlField && this.listDataChangeSource[i].controlField.value &&
        !this.listDataChangeSource[i].controlField.value.match(this.listDataChangeSource[i].regex)
      ){
        isValid = false
        break;
      }

      if(this.listDataChangeSource[i] && this.listDataChangeSource[i].controlField && this.listDataChangeSource[i].controlField.value &&
        this.listDataChangeSource[i].controlField.invalid
      ){
        isValid = false
        break;
      }
    }
    let isErrorValidateCustom = !!this.createContractMohaService.getErrorMessageStep3()
    this.createContractMohaService.isSuccessStep3.next(isValid && !isErrorValidateCustom)
    return (isValid && !isErrorValidateCustom)
  }

  markAsTouchedOrUnTouchedStep3(touched: boolean = true){
    for(let i = 0 ; i < this.listDataSource.length; i++){
      if(this.listDataSource[i] && this.listDataSource[i].controlField){
        if(touched){
          this.listDataSource[i].controlField.markAsTouched()
        }
        else{
          this.listDataSource[i].controlField.markAsUntouched()
        }
        this.listDataSource[i].controlField.updateValueAndValidity()
      }
    }
    for(let i = 0 ; i < this.listDataChangeSource.length; i++){
      if(this.listDataChangeSource[i] && this.listDataChangeSource[i].controlField){
        if(touched){
          this.listDataChangeSource[i].controlField.markAsTouched()
        }
        else{
          this.listDataChangeSource[i].controlField.markAsUntouched()
        }
        this.listDataChangeSource[i].controlField.updateValueAndValidity()
      }
    }
    this.validateDateRelations(this.listDataSource);
  }

  mappingDataMFFormService(isPatchValueCustomerMohaId: boolean = true){
    if(this.createContractMohaService.contractMohaFields && Array.isArray(this.createContractMohaService.contractMohaFields) && this.createContractMohaService.contractMohaFields.length){
      this.createContractMohaService.contractMohaFields.forEach((mfData: any) => {
        let existMFInTableIdx = this.listDataSource.findIndex((row: any) => row.code == mfData.key)
        if(existMFInTableIdx >= 0 && this.listDataSource[existMFInTableIdx] && this.listDataSource[existMFInTableIdx].controlField){
          if(mfData.value){
            if(this.listDataSource[existMFInTableIdx].inputType == 'DATETIME'){
              this.listDataSource[existMFInTableIdx].controlField.patchValue(new Date(mfData.value))
            }
            else{
              this.listDataSource[existMFInTableIdx].controlField.patchValue(mfData.value)
            }
          }
        }
      })
    }
    if(this.createContractMohaService.contractMohaUpdateFields && Array.isArray(this.createContractMohaService.contractMohaUpdateFields) && this.createContractMohaService.contractMohaUpdateFields.length){
      this.createContractMohaService.contractMohaUpdateFields.forEach((mfData: any) => {
        let existMFInTableIdx = this.listDataChangeSource.findIndex((row: any) => row.code == mfData.key)
        if(existMFInTableIdx >= 0 && this.listDataChangeSource[existMFInTableIdx] && this.listDataChangeSource[existMFInTableIdx].controlField){
          if(mfData.value){
            if(this.listDataChangeSource[existMFInTableIdx].inputType == 'DATETIME'){
              this.listDataChangeSource[existMFInTableIdx].controlField.patchValue(new Date(mfData.value))
            }
            else{
              this.listDataChangeSource[existMFInTableIdx].controlField.patchValue(mfData.value)
            }
          }
        }
      })
    }

    if(this.createContractMohaService.customerMohaId){
      if(this.listCustomer.find((customer) => customer.customerType && customer.customerId == this.createContractMohaService.customerMohaId)){
        this.customerControl.patchValue(this.createContractMohaService.customerMohaId, {emitEvent: isPatchValueCustomerMohaId})
      }
      else{
        if(this.listCustomer && this.listCustomer.length){
          this.customerControl.patchValue(this.listCustomer[0].customerId, {emitEvent: isPatchValueCustomerMohaId})
        }
        else{
          this.customerControl.patchValue(null, {emitEvent: isPatchValueCustomerMohaId})
        }
      }
    }

    let ngayHieuLucIdx = this.listDataSource.findIndex((tableItem: any) =>  tableItem.code == EnumCriteriaCode.ngay_bat_dau_hdld)
    let ngayHetHieuLucIdx = this.listDataSource.findIndex((tableItem: any) =>  tableItem.code == EnumCriteriaCode.ngay_ket_thuc_hdld)
    let typeContactSelect = this.listDataSource.findIndex((tableItem: any) =>  tableItem.code == EnumCriteriaCode.loai_hop_dong)
    let docCode = this.listDataSource.findIndex((tableItem: any) =>  tableItem.code == EnumCriteriaCode.ma_hop_dong)
    let maHopDongLucIdx = this.listDataSource.findIndex((tableItem: any) =>  tableItem.code == EnumCriteriaCode.ma_hop_dong)
    let phuongThucKy = this.listDataSource.findIndex((tableItem: any) =>  tableItem.code == EnumCriteriaCode.phuong_thuc_ky)
    let nghedochai = this.listDataSource.findIndex((tableItem: any) =>  tableItem.code == EnumCriteriaCode.nndh_is_doc_hai)

    let dataDocument: any = this.createContractMohaService.document.getValue()
    // if(ngayHieuLucIdx >= 0 && !this.listDataSource[ngayHieuLucIdx].controlField.value && dataDocument && dataDocument.effectiveDate){
    //   this.listDataSource[ngayHieuLucIdx].controlField.patchValue(dataDocument.effectiveDate);
    //   this.listDataSource[ngayHieuLucIdx].controlField.disable();
    // }

    // if(ngayHetHieuLucIdx >= 0 && !this.listDataSource[ngayHetHieuLucIdx].controlField.value && dataDocument && dataDocument.expiredDate){
    //   this.listDataSource[ngayHetHieuLucIdx].controlField.patchValue(dataDocument.expiredDate);
    //   this.listDataSource[ngayHetHieuLucIdx].controlField.disable();
    // }

    if(ngayHieuLucIdx >= 0 && this.createContractMohaService.effectiveDate){
      this.listDataSource[ngayHieuLucIdx].controlField.patchValue(this.createContractMohaService.effectiveDate);
      this.listDataSource[ngayHieuLucIdx].controlField.disable();
    }

    if(ngayHetHieuLucIdx >= 0 && this.createContractMohaService.expirationDate){
      this.listDataSource[ngayHetHieuLucIdx].controlField.patchValue(this.createContractMohaService.expirationDate);
      this.listDataSource[ngayHetHieuLucIdx].controlField.disable();
    }

    this.listDataSource[phuongThucKy].controlField.patchValue("2");
    this.listDataSource[phuongThucKy].controlField.disable();
    this.listDataSource[ngayHetHieuLucIdx].controlField.disable();

    if(maHopDongLucIdx){
      if (this.createContractMohaService.docCode) {
        this.listDataSource[maHopDongLucIdx].controlField.patchValue(this.createContractMohaService.docCode);
      } else {
        const codeAuto = this.message.getMessage('add_document_moha.contract_code_configured');
        this.listDataSource[maHopDongLucIdx].controlField.patchValue(codeAuto);
      }
      this.listDataSource[maHopDongLucIdx].controlField.disable();
    }

    if(this.createContractMohaService.selectedServiceType.value){
      const currentServiceType = this.createContractMohaService.selectedServiceType.value;
      //const typeContract = currentServiceType.employmentContractTerm;
      let typeDoc = "0"; 
      if(currentServiceType.employmentContractTerm === 'UNLIMITED'){
        typeDoc = "0";
      }else if(currentServiceType.employmentContractTerm === 'LIMITED'){
        typeDoc = "1";
      }
      this.listDataSource[typeContactSelect].controlField.patchValue(typeDoc);
      this.listDataSource[typeContactSelect].controlField.disable();
      //this.listDataSource[docCode].controlField.patchValue(this.createContractMohaService.docCode)
    }
  }

  getValueMFByCode(code: string){
    let row = this.listDataSource.find((row: any) => row.code == code)
    if(row && row.controlField){
      return row.controlField.value
    }
    return null
  }


  updateValueInService(row: any){
    this.createContractMohaService.isDirty = true
    if(this.createContractMohaService.contractMohaFields && this.createContractMohaService.contractMohaFields.length){
      this.createContractMohaService.contractMohaFields.forEach((field: any) => {
        if(field.key == row.code){
          field.value = row.controlField.value
        }
      })
    }
  }
  updateValueChangeInService(row: any){
      if(this.createContractMohaService.contractMohaUpdateFields && this.createContractMohaService.contractMohaUpdateFields.length){
        this.createContractMohaService.contractMohaUpdateFields.forEach((field: any) => {
          if(field.key == row.code){
            field.value = row.controlField.value
          }
        })
      }
  }

  getValueCriteriaByType(criteria: any){
    let data = ""
    switch (criteria.fieldConfig.type.code) {
      case "combobox":
        let rawValue = JSON.parse(criteria.value)
        if(rawValue.value !== null && rawValue.value !== undefined){
          data = rawValue.value
        }
        break;
      default:
        data = criteria.value
        break;
    }
    return data
  }

  checkValueInDropDown(row: any, key: any){
    let isExist: any = false
    let dataDropDownRow = this.optionsMap.get(row.code)
    if(dataDropDownRow && dataDropDownRow.length){
      isExist = dataDropDownRow.findIndex((item: any) =>
        this.commonService.extractUnicode(item.name).trim().toLowerCase() == this.commonService.extractUnicode(key).trim().toLowerCase()) >= 0
    }
    return isExist
  }

  getValueInDropdownByName(row: any, key: any){
    let data: any = null
    let dataDropDownRow = this.optionsMap.get(row.code)
    if(dataDropDownRow && dataDropDownRow.length){
      data = dataDropDownRow.find((item: any) =>
        this.commonService.extractUnicode(item.name).trim().toLowerCase() == this.commonService.extractUnicode(key).trim().toLowerCase())
    }
    return data ? data.value : null
  }

  checkIsValidDate(value: any){
    return this.validateDate(value) && !isNaN(this.formatDate(value).getTime())
  }

  getErrorDateMessage(pickerInput: string, isExpired?: boolean): string {
    if (!pickerInput || pickerInput === '') {
      return null;
    }
    return this.message.getMessage(isExpired ? 'validation.date_format_less_then_today' : 'validation.date_only_ddmmyyyy');
  }

  validateDate(value: any) {
    // Tách chuỗi bằng dấu "/"
    const parts = value.split(/\D/);
    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10); // Trừ 1 vì tháng bắt đầu từ 0
    const year = parseInt(parts[2], 10);

    const dt = new Date(year, month - 1, day);

    // Kiểm tra xem các giá trị sau khi khởi tạo có khớp với đầu vào không
    const matchesY = dt.getFullYear() === year;
    const matchesM = dt.getMonth() === month - 1;
    const matchesD = dt.getDate() === day;

    return matchesY && matchesM && matchesD;
  }

  formatDate(value: any){
    // Tách chuỗi bằng dấu "/"
    const parts = value.split(/\D/);
    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10) - 1; // Trừ 1 vì tháng bắt đầu từ 0
    const year = parseInt(parts[2], 10);

    const finalDate = new Date(year, month, day);
    return finalDate
  }

  getDDMMYYYY(value: any){
    // Tách chuỗi bằng dấu "/"
    const parts = value.split(/\D/);
    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10) - 1; // Trừ 1 vì tháng bắt đầu từ 0
    const year = parseInt(parts[2], 10);

    return day + '/' + month + '/' + year
  }
}
